import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";
import {useAppSelector} from '@/store/hooks.js';

const GET_STATEMENT_OPERATIONS_AND_INTERESTS = gql`
  query StatementOperationsAndInterests($consultantUuid: ID!, $year: Int!, $month: Int) {
    statementOperationsAndInterests(statementOperationsAndInterestsRequest: {
      consultantUuid: $consultantUuid,
      year: $year,
      month: $month
    }) {
      days {
        day
        statementOperations {
          uuid
          valueDate
          operationType
          amount
          amountEur
          currency
          linkedEntityUuid
          linkedEntityPeriod
          beforeBalance
          afterBalance
          impactsOverflow
          editable
          comment
        }
        statementInterests {
          uuid
          consultantUuid
          year
          month
          interestDate
          amountEur
          accruedInterestsEur
          paidInterestsEur
          interestsBalanceEur
          linkedStatementOperationUuid
        }
      }
    }
  }
`;

export const useStatementOperationsAndInterests = (year, month, isAdmin= true, idFromParams) => {
    const user = useAppSelector((state) => state.auth.currentUser);
    const { id: consultantUuid } = useParams();
    let uuid = isAdmin ? (idFromParams || consultantUuid) : user.uuid;

    // console.log("useStatementOperationsAndInterests", year, month, uuid);
    if (!uuid || !year) return {};

    const variables = { consultantUuid : uuid, year: parseInt(year) };
    if (month !== undefined && month !== null) {
        variables.month = parseInt(month);
    }

    const { loading, error, data, refetch } = useQuery(GET_STATEMENT_OPERATIONS_AND_INTERESTS, {
        variables,
        fetchPolicy: "network-only",
        // skip: !year || year === "" ,
    });

    return { loading, error, data: data?.statementOperationsAndInterests, refetch };
};
